import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '@/lib/api';
import { useAuth } from './AuthContext';

const FeatureFlagsContext = createContext({
  flags: {},
  loading: true,
  ready: false,
  refresh: () => {},
});

export const FeatureFlagsProvider = ({ children }) => {
  const { user } = useAuth();
  const [flags, setFlags] = useState({});
  const [loading, setLoading] = useState(true);
  const [ready, setReady] = useState(false);

  const fetchFlags = useCallback(async () => {
    if (!user) {
      setFlags({});
      setLoading(false);
      setReady(true);
      return;
    }
    try {
      setLoading(true);
      const r = await api.get('/feature-flags/me');
      setFlags(r.data?.flags || {});
    } catch (e) {
      // Soft-fail — flags simply unavailable, default to off
      setFlags({});
    } finally {
      setLoading(false);
      setReady(true);
    }
  }, [user]);

  useEffect(() => {
    fetchFlags();
  }, [fetchFlags]);

  const value = {
    flags,
    loading,
    ready,
    refresh: fetchFlags,
  };

  return (
    <FeatureFlagsContext.Provider value={value}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlagsContext = () => useContext(FeatureFlagsContext);
